import { ButtonTriggerEvent } from '../';

export class InputModalActions {
    confirm: (event: ButtonTriggerEvent, data: string) => void;
    cancel?: () => void;
}

export class InputModalData {
    inputModalTitle?: string;
    inputModalHelpText?: string;
    inputModalValue?: string;
    inputModalConfirmButtonText?: string;
    inputModalCancelButtonText?: string;
    isAsync?: boolean;

    constructor(title: string, helpText: string, value: string, confirmBtnText: string, cancelBtnText: string, isAsync: boolean) {
        this.inputModalTitle = title;
        this.inputModalHelpText = helpText;
        this.inputModalValue = value;
        this.inputModalConfirmButtonText = confirmBtnText;
        this.inputModalCancelButtonText = cancelBtnText;
        this.isAsync = isAsync;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/input.modal/input.modal.provider.ts